import { render, staticRenderFns } from "./MaterialRequestOverviewView.vue?vue&type=template&id=51e40c3b&scoped=true&"
import script from "./MaterialRequestOverviewView.vue?vue&type=script&lang=ts&"
export * from "./MaterialRequestOverviewView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e40c3b",
  null
  
)

export default component.exports